import React from 'react';
import {
	CameraFilled,
	CameraOutlined,
	SkinFilled,
	SkinOutlined,
	VideoCameraFilled,
	VideoCameraOutlined,
} from '@ant-design/icons';
import { User, userAtom } from '../store/user';
import { AntdIconProps } from '@ant-design/icons/lib/components/AntdIcon';
import { Spin } from 'antd';
import { useAtomValue } from 'jotai';
import { focusResaAtom } from '../store/core';
import { FormattedMessage } from 'react-intl';

export const IconForUser = ({
	user,
	filled,
	...props
}: {
	user: User;
	filled?: boolean;
} & AntdIconProps) => {
	if (user.roles.includes('um_photographers'))
		return filled ? <CameraFilled {...props} /> : <CameraOutlined {...props} />;
	if (user.roles.includes('um_videographers'))
		return filled ? (
			<VideoCameraFilled {...props} />
		) : (
			<VideoCameraOutlined {...props} />
		);
	if (user.roles.includes('um_cosplayers'))
		return filled ? <SkinFilled {...props} /> : <SkinOutlined {...props} />;
};

export const UserLabel = (props: {
	user?: User;
	userId?: number;
	accepted?: boolean;
	ifSelf?: 'you' | 'me';
	short?: boolean;
	clickable?: boolean;
}) => {
	const user = useAtomValue(userAtom(props.user?.ID ?? props.userId ?? 0));
	const loggedInUser = useAtomValue(focusResaAtom).loggedInUser;
	if ((user?.ID ?? props.userId) == loggedInUser) {
		if (props.ifSelf == 'me')
			return (
				<span>
					<FormattedMessage defaultMessage="moi" id="44IMPu" />
				</span>
			);
		if (props.ifSelf == 'you')
			return (
				<span>
					<FormattedMessage defaultMessage="vous" id="SBbddw" />
				</span>
			);
	}

	if (!user) return <Spin size="small" />;

	const label = (
		<span
			style={{ display: 'inline-flex', gap: '0.2em', alignItems: 'baseline' }}
		>
			{
				<IconForUser
					user={user}
					filled={props.accepted}
					style={{ alignSelf: 'center' }}
				/>
			}
			{props.short ? user.display_name.substring(0, 0) : user.display_name}
		</span>
	);

	return props.clickable ? (
		<a
			href={user.link}
			onMouseDown={(e) => e.stopPropagation()}
			onClick={(e) => e.stopPropagation()}
			target="_blank"
			rel="noreferrer"
		>
			{label}
		</a>
	) : (
		label
	);
};
